<main>
  <div class="cont-sup">
    <h5 class="title">Ordenes de pago</h5>
    <button mat-icon-button color="primary" aria-label="button with a mail icon" matTooltip="Enviar consulta por mail" matTooltipPosition="left" routerLink="/home/mailing/pro">
      <mat-icon>mail</mat-icon>
    </button>
  </div>
    <div class="cards">
      <div>
        <mat-form-field appearance="fill">
          <mat-label>Fecha desde</mat-label>
          <input matInput [matDatepicker]="picker1" [value]="fecha_desde_moment" (dateChange)="dateChanged($event)">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
      <div >
        <mat-form-field appearance="fill">
          <mat-label>Fecha hasta</mat-label>
          <input matInput [matDatepicker]="picker2" [value]="fecha_hasta_moment" (dateChange)="dateChanged2($event)">
          <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="card-single">
          <span>${{contador | number: '.2'}}</span>
          <span>Total</span>
      </div>
      
    </div>


    <div class="recent-grid">
      <div class="example-loading-shade"
      *ngIf="isLoadingResults">
        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
      </div>
      <div class="img-nf" *ngIf="!estaVacio">
        <img src="assets/img/notFound.svg" alt="">
        <h5>Ups! No existen datos para la consulta</h5>
    </div>
      <div class="mat-elevation-z8 example-table-container" *ngIf="estaVacio">
          <table mat-table [dataSource]="dataSource">
        
            <!-- Position Column -->
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let comp"> {{comp.estado}} </td>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="descrip">
              <th mat-header-cell *matHeaderCellDef style="text-align: start;"> Comprobante </th>
              <td mat-cell *matCellDef="let comp" style="text-align: start;"> {{comp.descrip}} </td>
            </ng-container>
        
            <!-- Weight Column -->
            <ng-container matColumnDef="num">
              <th mat-header-cell *matHeaderCellDef> Nro. </th>
              <td mat-cell *matCellDef="let comp"> {{comp.num}} </td>
            </ng-container>
        
            <!-- Symbol Column -->
            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef> Fecha </th>
              <td mat-cell *matCellDef="let comp"> {{comp.fecha}} </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef> Total </th>
              <td mat-cell *matCellDef="let comp"> {{comp.mone}} {{comp.total | number: '.2'}} </td>
            </ng-container>

            <ng-container matColumnDef="fecha_vencimiento">
              <th mat-header-cell *matHeaderCellDef> Venc. </th>
              <td mat-cell *matCellDef="let comp"> {{comp.fecha_vencimiento}} </td>
            </ng-container>
<!-- 
            <ng-container matColumnDef="obser">
              <th mat-header-cell *matHeaderCellDef> Obser. </th>
              <td mat-cell *matCellDef="let comp"> {{comp.obser}} </td>
            </ng-container> -->

            <ng-container matColumnDef="descarga">
              <th mat-header-cell *matHeaderCellDef>OP</th>
              <td mat-cell *matCellDef="let comp"> 
                <button mat-icon-button aria-label="Descargar comprobante" (click)="desc_comp(comp.descarga,'OP')">
                  <mat-icon color="primary">local_printshop</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="cantidad_reten">
              <th mat-header-cell *matHeaderCellDef>Retenciones</th>
              <td mat-cell *matCellDef="let comp"> 
                <button mat-icon-button aria-label="Descargar comprobante" *ngIf="comp.cantidad_reten>0" (click)="desc_comp(comp.descarga,'RET')">
                  <mat-icon color="primary">local_printshop</mat-icon>
                </button>
              </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        
        </div>
      </div>
      <mat-paginator *ngIf="estaVacio" [pageSizeOptions]="[15]"
                     showFirstLastButtons
                     aria-label="Select page of periodic elements">
      </mat-paginator>
  </main>
